<template>
  <el-menu
    class="el-menu-vertical-demo"
    background-color="#2e3b4e"
    text-color="#fff"
    active-text-color="#ffd04b"
    :router="true"
    :default-active="defaultActive"
    :unique-opened="true"
  >
    <menu-item
      v-for="menu in menuList"
      :key="menu.path"
      :menu="menu"
      base-path=""
    ></menu-item>
  </el-menu>
</template>

<script>
import { mapState } from 'vuex'
import MenuItem from '@/components/MenuItem'

export default {
  name: 'LayoutSidebar',
  components: { MenuItem },
  computed: {
    ...mapState('user', ['menuList']),
    defaultActive() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.el-menu-vertical-demo {
  height: 100%;
  border-right: none;
}
</style>